import React from 'react';

import PropTypes from 'prop-types';

import { EventRegisterFormFieldWrapper } from 'components/Event/EventRegisterForm/EventRegisterFormFieldWrapper';
import { ThemedTextField } from 'components/ThemedTextField/ThemedTextField';

import { TENANT_ID } from 'global/constants';

export const EventRegisterCompanyFields = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  tenant,
  iamType,
}) => {
  const showExtendedCompanyFields = iamType !== 'EIAM';

  return (
    <div className="event-register-form__registration-wrapper">
      <div className="event-register-form__participant-column-wrapper">
        <EventRegisterFormFieldWrapper>
          <ThemedTextField
            fullWidth
            disabled
            id="firmenname1"
            name="firmenname1"
            label="Firmenname1*"
            variant="standard"
            value={values.firmenname1}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.firmenname1 && Boolean(errors.firmenname1)}
            helperText={touched.firmenname1 && errors.firmenname1}
          />
        </EventRegisterFormFieldWrapper>
        {showExtendedCompanyFields && (
          <EventRegisterFormFieldWrapper>
            <ThemedTextField
              fullWidth
              disabled
              id="firmenname2"
              name="firmenname2"
              label="Firmenname2"
              variant="standard"
              value={values.firmenname2}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.firmenname2 && Boolean(errors.firmenname2)}
              helperText={touched.firmenname2 && errors.firmenname2}
            />
          </EventRegisterFormFieldWrapper>
        )}
        {tenant === TENANT_ID.BAG && showExtendedCompanyFields && (
          <EventRegisterFormFieldWrapper>
            <ThemedTextField
              fullWidth
              disabled
              id="firmenname3"
              name="firmenname3"
              label="Firmenname3"
              variant="standard"
              value={values.firmenname3}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.firmenname3 && Boolean(errors.firmenname3)}
              helperText={touched.firmenname3 && errors.firmenname3}
            />
          </EventRegisterFormFieldWrapper>
        )}
      </div>
      <div className="event-register-form__participant-column-wrapper">
        <EventRegisterFormFieldWrapper>
          <ThemedTextField
            fullWidth
            disabled
            id="installerEmail"
            name="installerEmail"
            label="E-Mail für Informationsversand*"
            variant="standard"
            value={values.installerEmail}
          />
          {!showExtendedCompanyFields && (
            <div className="event-register-form__email-information">
              Die Veranstaltungseinladung und ggf. Veranstaltungsinformationen werden an diese
              E-Mail-Adresse gesendet.
            </div>
          )}
          {showExtendedCompanyFields && (
            <div className="event-register-form__email-information">
              Tragen Sie E-Mail-Adressen der Fachkräfte ein, damit die Veranstaltungseinladung und
              ggf. Veranstaltungsinformationen an diese gesendet werden
            </div>
          )}
        </EventRegisterFormFieldWrapper>
      </div>
    </div>
  );
};

EventRegisterCompanyFields.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  tenant: PropTypes.string.isRequired,
  iamType: PropTypes.string.isRequired,
};
